import Vue from 'vue'
import App from './App.vue'

import VueRouter from 'vue-router'
Vue.use(VueRouter)


import VueClazyLoad from 'vue-clazy-load';
Vue.use(VueClazyLoad);

import {routes} from './routes'

const router = new VueRouter({
    history:false,
    routes: routes
})

import VueScrollTo from 'vue-scrollto';
Vue.use(VueScrollTo)

var vm = new Vue({
  el: '#toolkit-app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js